/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';

  
    const { basePath = '', loginPath = '' } = getHost("PRO_XY_LIVE", "566")
  

// 接口文档

  
    
export interface IAPI76998ResListItem {
  
  /** 会话名称 */
  sessionName?: string;
  
  /** 会话编号 */
  sessionCode?: string;
  
};
    
  



export interface API76998Req {
  
  /** 会话名称 */
  sessionName?: string;
    
  /**  */
  pageSize?: string;
    
  /**  */
  pageIndex?: string;
    
  /**  */
  rowId?: string;
    
  /**  */
  jumpType?: string;
    
  /**  */
  searchCount?: string;
    
  /**  */
  orderObjects?: string;
    
};



export interface API76998Res {
  /** T  */
  list?: IAPI76998ResListItem[];
  /**   */
  totalNumber?: number;
  /**   */
  totalPage?: number;
  /**   */
  rowId?: string;
  /**   */
  hasNext?: boolean;
  /**   */
  pageSize?: number;
  /**   */
  pageIndex?: number;
  
};


// 接口函数 76998 分页查询session

export interface IUseGetAPI76998Return {
  /** 分页查询session: 接口请求状态 */
  isAPI76998Loading: boolean;
  /** 分页查询session: 接口请求返回数据 */
  dataAPI76998: API76998Res;
  /**  分页查询session: 接口数据请求方法 */
  fetchAPI76998Data: (inputs: API76998Req, config?: YWRequestConfig) => Promise<API76998Res>;
  /** 分页查询session: 接口请求URL */
  requestUrl: string;
}

export const useGetAPI76998 = ():IUseGetAPI76998Return => {
  let isMount = true;
  const [isAPI76998Loading, setIsAPI76998Loading] = useState(false);
  const [dataAPI76998, setDataAPI76998] = useState<API76998Res>({} as API76998Res);
  const requestUrl = `${basePath}/yoaichat-admin/chat/session/page`;

  const fetchAPI76998Data = async (inputs: API76998Req, config?: YWRequestConfig): Promise<API76998Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API76998Req>) || {}) as API76998Req;
    
  
    if ( isMount ) {
      setIsAPI76998Loading(true);
    }

    try {
      
      
      const res: any = await Request.get<API76998Res>(`${basePath}/yoaichat-admin/chat/session/page?${querystring.stringify(params as any)}`, {
        loginHost: loginPath,
        ...config
      });
      
      
      
      if (isMount) {
        setDataAPI76998(res || {} as API76998Res);
        setIsAPI76998Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI76998Loading(false);
      }
      return false as unknown as API76998Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI76998Loading,
    dataAPI76998,
    fetchAPI76998Data,
    requestUrl,
  }
}

